<template>
  <div class="mb-4">
    <div v-if="state == 'loading'" class="text-center py-5">
      <a :href="`${baseUrl}kaleido/`" class="btn btn-outline-primary" target="_blank" rel="noopener">Show all jobs</a>
    </div>

    <div v-if="state == 'done'">
      <div class="accordion py-5" id="jobsAccordion">
        <div v-for="(jobs, department, index) in jobsByDepartment" :key="department" class="card">
          <div :id="`heading-${parameterize(department)}`"
               class="card-header bg-white d-flex justify-content-between align-items-center px-3 py-3"
               :class="{ collapsed: index > 0 }"
               data-toggle="collapse" :data-target="`#collapse-${parameterize(department)}`"
               :aria-controls="`collapse-${parameterize(department)}`">
            <div class="d-flex align-items-center">
              <h4 class="h5 mb-0">{{ department }}</h4>
              <span class="badge text-white bg-danger ml-2">{{ jobs.length }}</span>
            </div>
            <i class="fas fa-plus"></i>
          </div>
           <div :id="`collapse-${parameterize(department)}`" class="collapse" :class="{ show: index == 0 }"
                :aria-labelledby="`heading-${parameterize(department)}`" data-parent="#jobsAccordion">
              <div class="card-body py-0">
                  <div v-for="(job, jobIndex) in jobs" :key="job.shortcode">
                    <div class="d-flex align-items-center justify-content-between" :class="{ 'border-bottom': jobIndex != jobs.length - 1 }">
                      <div class="py-3">
                        <a :href="job.url" class="h5" target="_blank" rel="noopener">{{ job.title }}</a>
                        <div class="text-muted small mt-1">
                          <span class="d-inline-block mr-2" v-if="jobLocation(job).length > 0"><i class="fas fa-building pr-1"></i> {{ jobLocation(job) }}</span>
                          <span class="d-inline-block" v-if="job.employment_type.length > 0"><i class="fas fa-clock pr-1"></i> {{ job.employment_type }}</span>
                        </div>
                      </div>
                      <div>
                        <a :href="job.url" class="btn btn-outline-primary px-5 d-none d-md-block" target="_blank" rel="noopener">Learn more</a>
                        <a :href="job.url" class="d-md-none"  target="_blank" rel="noopener"><i class="fas fa-chevron-right"></i></a>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
        </div>
      </div>
    </div>

    <div class="text-center py-4 mx-auto" style="max-width: 650px;">
      <h6>Can't find your job?</h6>
      <p class="mb-1">
        Don't worry, Kaleido is currently growing fast and is looking for experienced talents in all departments.
        <a :href="`${baseUrl}kaleido/j/1FA3C2E9CC/`" target="_blank" rel="noopener">Send us your unsolicited application.</a>
      </p>

    </div>
  </div>
</template>

<script>
export default {
  name: "open-jobs",

  data() {
    return {
      baseUrl: "https://apply.workable.com/",
      state: "loading",
      jobs: [],
    }
  },

  computed: {
    jobsByDepartment() {
      const groupKey = "department"

      let groupedJobs =  this.jobs.reduce(
        (result, item) => ({
          ...result,
          [item[groupKey]]: [
            ...(result[item[groupKey]] || []),
            item,
          ],
        }),
        {},
      )

      // Don't display the unsolicited department
      delete groupedJobs["Unsolicited"]

      // Place uncatageorized jobs into a "Other" group
      if(groupedJobs.hasOwnProperty("null")) {
        delete Object.assign(groupedJobs, {["Other"]: groupedJobs["null"] })["null"];
      }

      return groupedJobs
    },
  },

  mounted() {
    this.loadJobs()
  },

  methods: {
    loadJobs() {
      const self = this
      self.state = "loading"

      $.ajax({
        url: `${this.baseUrl}/api/v1/widget/accounts/381974?origin=embed&callback=whrcallback&details=true`,
        jsonp: "callback",
        dataType: "jsonp",
        success(response) {
          self.jobs = response.jobs
          self.state = "done"
        },
      })
    },

    jobLocation(job) {
      return [job.city, job.country].filter(el => el.length > 0).join(", ")
    },

    parameterize(value) {
      return value.trim().toLowerCase().replace(/[^a-zA-Z0-9 -]/, "").replace(/\s/g, "-");
    }
  }
}
</script>

<style lang="scss" scoped>
  .card-header {
    cursor: pointer;

    i {
      color: #0F70E6;
      transition-duration: 0.3s;
      transition-property: transform;
      transform: rotate(45deg);
    }

    &.collapsed {
      i {
        transform: rotate(0deg);
      }
    }
  }
</style>
